// Entry point for the build script in your package.json
import '@remark/components/build/components/index.js';
import * as ActiveStorage from '@rails/activestorage';
import '../controllers';
import '../stream_actions';

ActiveStorage.start();
